/* tslint:disable */
import {version} from '../../package.json';

export const environment = {
    appVersion: version,
    production: true,
    metaUrl: 'https://luckytrip.co.uk/',
    adminUrl: 'https://api.luckytrip.co.uk/admin/',
    versionCheckURL: 'https://luckytrip.co.uk/version.json',
    apiUrl: {
        baseUrl: 'https://api.luckytrip.co.uk/api/',
        services: {
            login: '2.0/user/login',
            registration: '2.0/user',
            refreshToken: '2.0/user/refresh/token',
            userBookings: '2.0/user/checkouts',
            userBookedTrip: '2.0/user/checkout',
            publicVouchers: '2.0/user/public_vouchers',
            logout: '2.0/user/logout',
            fbLogin: '2.0/user/login/facebook',
            gLogin: '2.0/user/login/google',
            passwordRecovery: '2.0/user/password/recovery',
            passwordReset: '2.0/user/password/reset',
            generateCheckout: '2.0/checkout',
            checkout: '2.0/checkout/payment',
            passengers: '2.0/checkout/passengers',
            passenger: '2.0/checkout/passenger',
            subscribe: '2.0/user/subscribe',
            configurations: '2.0/content/configurations',
            checkoutConfigurations: '2.0/content/configurations',
            countries: '2.0/content/countries',
            airports: '2.0/search/airports',
            lucky: '2.0/trip/lucky',
            roomAvailability: '2.0/trip/room/availability',
            activityAvailability: '2.0/trip/activity/availability',
            avatar: '2.0/user/avatar',
            flightGrid: '2.0/trip/flight/grid_data',
            weightedFlightGrid: '2.0/trip/flight/weighted_grid_data',
            flighPriceListing: '2.0/trip/flight/price_listing',
            trip: '2.0/trip',
            shareTrip: '2.0/trip/share',
            exploreTrip: '2.0/explore/trip',
            roomOptions: '2.0/trip/room/options',
            savedTrips: '2.0/trip/list',
            airportsByDest: '2.0/search/airports_by_destination',
            wallet: '2.0/user/wallet/get',
            validateCard: '2.0/checkout/validate_card',
            tripBreak: '2.0/trip/break',
            checkouts: {
                configurations: '2.0/content/configurations',
                checkouts: '2.0/checkouts',
            },
            destination: '2.0/destinations',
            whereTo: '2.0/search/where_to',
            sitemap: '2.0/site_map',
            savedPassengers: '2.0/passengers',
        },
        pages: {
            post: {
                content: '2.0/explore/post',
                carousel: '2.0/explore/posts',
                savedPosts: '2.0/explore/user/posts',
                userPost: '2.0/explore/user/post',
                directPayment: '2.0/explore/post/direct_payment_block',
            },
            activity: {
                carousel: 'ej/activities',
                content: 'ej/activity'
            },
            trip: {
                content: '2.0/trip/share',
                reschedule: '2.0/trip/scheduled'
            }
        },
    },
    mixpanel: {
        project_token: '76d145de5b2aac1a22fbc1fbafb50fcc',
        debug: false,
    },
    giftup: {
        base_url: 'https://api.giftup.app',
        API_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIxYjEyNjE2NS1iMGViLTRkNWEtYmQ1OC0wNDk1M2FiMzA0OTMiLCJzdWIiOiJtYWhtb3VkLmFidXNlaW5pQGx1Y2t5dHJpcC5jby51ayIsImV4cCI6MTg1NjYxNDAxNywiaXNzIjoiaHR0cHM6Ly9naWZ0dXAuYXBwLyIsImF1ZCI6Imh0dHBzOi8vZ2lmdHVwLmFwcC8ifQ.Ae6FfrwB86G70Xw-7HiC0ULJXm_mTqSQUxNpFtODWkI',
        TEST_MODE: false,
    },
    iplocation: {
        fetchIp: 'https://jsonip.com',
        fetchGeolocation: 'https://pro.ip-api.com/json',
        key: 'UFbeuTmZRqP7kad'
    },
    FACEBOOK_APP_ID: '1600868486809061',
    GOOGLE_OAUTH_CLIENT_ID: '412527140586-khjm6l5ej2vofsgfsdqaievo5u2i1tns.apps.googleusercontent.com',
    terms_and_conditions_level: 1,
    marketing_level: 1,
    slaask: {
        is_enabled: true,
        widget_key: '370368acab3c69eb4d61d755d06c8ba5',
        booking_widget_key: 'ffa587dace8abe9a2803dd2dd15be7d1',
    },
    stripe: {
        key: 'pk_live_wtM4KNsEAjKXgrlmJ6UDRZzG',
        image: 'https://api.luckytrip.co.uk/static/payment/images/logo.svg',
    },
    store: {
        ios: 'https://itunes.apple.com/app/luckytrip-a-trip-in-one-tap/id973059290?mt=8',
        android: 'https://play.google.com/store/apps/details?id=com.luckytrip.luckytrip',
    },
    firebase: {
        apiKey: "AIzaSyAqh0dWMVrOxSkbCFro4ddrDUTXMUPxfbE",
        authDomain: "luckytrip-cd4aa.firebaseapp.com",
        databaseURL: "https://luckytrip-cd4aa.firebaseio.com",
        projectId: "luckytrip-cd4aa",
        storageBucket: "luckytrip-cd4aa.appspot.com",
        messagingSenderId: "585659097582",
        appId: "1:585659097582:web:cdf8287234a0ccbcdeaeff",
        measurementId: "G-MK6QKJS9QK"
    }
};
